const chatbotData = [
  // --- Getting Started ---
  {
    keywords: ['what', 'platform', 'about', 'yourbig', 'bigyear', 'your big year'],
    question: 'What is this platform?',
    answer:
      'YourBigYear is a Learning Management System designed to help you take courses, track your progress, submit your advocacy work, and achieve your learning goals.'
  },
  {
    keywords: ['get', 'started', 'begin', 'start', 'new', 'how'],
    question: 'How do I get started?',
    answer:
      'Once you log in, head to the Dashboard to see your enrolled courses and upcoming events. You can browse available courses and learning paths from the navigation menu.'
  },

  // --- Courses ---
  {
    keywords: ['course', 'courses', 'enroll', 'find', 'browse', 'join'],
    question: 'How do I find and enroll in courses?',
    answer:
      'Navigate to the Courses section from the sidebar. Browse available courses and enroll in ones that interest you. Your enrolled courses will appear on your Dashboard.'
  },
  {
    keywords: ['lesson', 'lessons', 'watch', 'read', 'open', 'view'],
    question: 'How do I access lessons?',
    answer:
      'Open a course you\'re enrolled in and you\'ll see the list of lessons. Click on a lesson to view its content. Lessons may include text, images, videos, and embedded media.'
  },

  // --- Learning Paths ---
  {
    keywords: ['path', 'paths', 'learning path', 'track', 'curriculum'],
    question: 'What are learning paths?',
    answer:
      'Learning paths are structured sequences of courses designed to guide you through a topic. They help you follow a recommended order for a complete learning experience.'
  },

  // --- Submissions ---
  {
    keywords: ['submit', 'submission', 'advocacy', 'upload', 'hand in', 'turn in'],
    question: 'How do I submit my advocacy work?',
    answer:
      'Open the advocacy work from your course, fill in the required fields, and click Submit. You can track your submission status from the Submissions section on your dashboard.'
  },
  {
    keywords: ['grade', 'grading', 'feedback', 'mark', 'score', 'result'],
    question: 'Where can I see my grades and feedback?',
    answer:
      'Check the Submissions section on your dashboard. Once your instructor reviews your work, you\'ll see your grade and any feedback they\'ve provided.'
  },
  {
    keywords: ['resubmit', 'redo', 'again', 'retry', 'fix', 'edit submission'],
    question: 'Can I resubmit my advocacy work?',
    answer:
      'This depends on your course settings. Check the advocacy work details or ask your instructor if resubmission is allowed.'
  },

  // --- Progress ---
  {
    keywords: ['progress', 'track', 'completion', 'percentage', 'status', 'complete'],
    question: 'How do I track my progress?',
    answer:
      'Your Dashboard shows progress for all enrolled courses. Each course displays a completion percentage based on lessons you\'ve finished.'
  },
  {
    keywords: ['xp', 'experience', 'points', 'level', 'gamification'],
    question: 'What is the XP system?',
    answer:
      'You earn XP (experience points) by completing lessons, finishing courses, and submitting your advocacy work. XP tracks your overall engagement and progress on the platform.'
  },
  {
    keywords: ['badge', 'badges', 'achievement', 'achievements', 'reward'],
    question: 'How do badges work?',
    answer:
      'Badges are awarded for completing milestones like finishing courses or reaching XP goals. View your earned badges from your profile or dashboard.'
  },

  // --- Events ---
  {
    keywords: ['event', 'events', 'calendar', 'schedule', 'date', 'deadline'],
    question: 'Where can I see upcoming events and deadlines?',
    answer:
      'Check the Events section to see upcoming deadlines, live sessions, and important dates. Events also appear on your dashboard calendar.'
  },

  // --- Account ---
  {
    keywords: ['profile', 'account', 'edit profile', 'personal', 'info'],
    question: 'How do I update my profile?',
    answer:
      'Click on your profile picture or name in the navigation bar to access your profile page. From there you can update your personal information and profile picture.'
  },
  {
    keywords: ['password', 'change password', 'reset', 'forgot', 'security'],
    question: 'How do I change my password?',
    answer:
      'Go to your Profile settings to change your password. If you forgot your password, use the "Forgot Password" link on the login page to reset it.'
  },
  {
    keywords: ['login', 'log in', 'sign in', 'access', 'cant login'],
    question: "I can't log in. What should I do?",
    answer:
      'Make sure you\'re using the correct email and password. If you forgot your password, use the "Forgot Password" option. If issues persist, contact your administrator.'
  },

  // --- Notifications ---
  {
    keywords: ['notification', 'notifications', 'alert', 'alerts', 'updates'],
    question: 'How do notifications work?',
    answer:
      'You receive notifications for important events like new course updates, submission feedback, and announcements. Check the notification bell icon in the top navigation.'
  },

  // --- Support ---
  {
    keywords: ['help', 'support', 'contact', 'issue', 'problem', 'bug', 'error'],
    question: 'How do I get help?',
    answer:
      'If you\'re experiencing issues or need help, please reach out to your instructor or platform administrator. They can assist with technical issues and answer your questions.'
  },
  {
    keywords: ['referral', 'refer', 'invite', 'friend', 'share'],
    question: 'How do referrals work?',
    answer:
      'You can refer friends to the platform using the referral feature. Check your dashboard or profile for your referral link to share with others.'
  }
];

export default chatbotData;
